<app-accounts-list *ngIf="route.children.length === 0"></app-accounts-list>
<router-outlet></router-outlet>